import React from 'react'

import { cn } from '@/lib/utils'

import { Checkbox as BaseCheckbox } from '../ui/checkbox'

const Checkbox = React.forwardRef<
  React.ComponentRef<typeof BaseCheckbox>,
  React.ComponentPropsWithoutRef<typeof BaseCheckbox>
>(({ className, ...props }, ref) => (
  <BaseCheckbox
    ref={ref}
    className={cn(
      'data-[state=checked]:border-primary',
      '[&_svg]:size-2.5 [&_svg]:text-white xl:[&_svg]:size-4',
      'size-3 border-white xl:size-4',
      className
    )}
    {...props}
  />
))

export default Checkbox
